import React from 'react';
import DropdownMenu from './DropdownMenu';
import DropdownMenuItem from './ReportDropdown';

const options = [
  {
    label: 'Needs Attention',
    value: 'FOLLOWUP_NEEDED',
    className: 'needs_attention',
    iconclassName: 'priority_high',
  },
  {
    label: 'Resolved',
    value: 'HANDLED',
    className: 'mark_resolved',
    iconclassName: 'check',
  },
];

const MarkAsResolved = ({ onChange, selectedOption, ...rest }) => {
  let filteredOptions = options.filter((option) => option.value !== selectedOption);
  return (
    <DropdownMenu {...rest}>
      {/* eslint react/no-array-index-key: "off" */
      filteredOptions.map((item, index) => {
        return (
          <DropdownMenuItem
            label={item.label}
            key={index}
            value={item.value}
            onClick={onChange}
            type="BUTTON"
            className={item.className}
            iconclassName={item.iconclassName}
          />
        );
      })}
    </DropdownMenu>
  );
};

export default MarkAsResolved;
